export default "__VITE_ASSET__oIZ8F$N5__"